import type { PageComponent } from '../../router'
import { CollectionPageController } from './CollectionPageController'
import { collectionPageTemplate } from './collectionPageTemplates'

/** Mounts after collection readiness; subsequent navigation reuses the controller. */
const CollectionPage: PageComponent = {
	async mount(context) {
		const { containerEl, user, signal } = context
		if (!user) throw new Error('Authentication required')
		containerEl.innerHTML = collectionPageTemplate()
		const root = containerEl.querySelector<HTMLElement>(
			'#collection-section',
		)
		if (!root) throw new Error('Missing collection page')

		const controller = new CollectionPageController(root, user, context)
		signal.addEventListener('abort', () => controller.dispose(), {
			once: true,
		})
		await controller.ready
		signal.throwIfAborted()
		return controller
	},
}

export default CollectionPage
